import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'
import { CloseOpportunitySuccessModalProps } from './CloseOpportunitySuccessModal.types'

export function CloseOpportunitySuccessModal({ open, handleClose }: Readonly<CloseOpportunitySuccessModalProps>) {
  const { t } = useTranslation()

  return (
    <Modal open={open} onClose={handleClose}>
      <AcknowledgeModal
        result="positive"
        title={t('dialog.volunteering.close.success.title')}
        description={t('dialog.volunteering.close.success.description')}
        buttonText={t('button.close')}
        handleClose={handleClose}
      />
    </Modal>
  )
}
